import { ComingSoon } from 'components/shared/comingSoon/comingSoon';
import React from 'react';

export const Projects: React.FC = () => (
  <ComingSoon name="The Projects page" />
);
